import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "#",
      role: "button",
      class: "secondary botaoCancelar",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('cancelou')), ["prevent"]))
    }, "Cancelar"),
    _createElementVNode("a", {
      href: "#",
      role: "button",
      class: "botaoSalvar",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('salvou')), ["prevent"]))
    }, "Salvar")
  ], 64))
}